import { render, staticRenderFns } from "./TitleSize.vue?vue&type=template&id=aeeabc76"
import script from "./TitleSize.vue?vue&type=script&lang=js"
export * from "./TitleSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports